import _ from 'lodash';
const localStorageName = `${location.hostname}-ai`;
const COMPONENT_EXPIRY_TIME = 24 * 60 * 60 * 1000;
const setLocalStorage = (localStorageData) => {
    localStorage.setItem(localStorageName, JSON.stringify(localStorageData));
};
export const getLocalStorage = () => {
    const data = JSON.parse(localStorage.getItem(localStorageName) || '{}');
    if (data.timestamp) {
        const storedDate = new Date(data.timestamp).toDateString();
        const currentDate = new Date().toDateString();
        if (storedDate !== currentDate) {
            removeLocalStorage();
            return {};
        }
    }
    return data;
};
export const removeLocalStorage = () => {
    localStorage.removeItem(localStorageName);
};
export const updateConversation = (conversation) => {
    const aiLocalStorage = getLocalStorage();
    setLocalStorage(Object.assign(Object.assign({}, aiLocalStorage), { conversation, timestamp: Date.now() }));
};
export const getLocalStorageMessages = () => {
    const aiLocalStorage = getLocalStorage();
    const messagesData = _.get(aiLocalStorage, 'conversation', '[]');
    try {
        const parsed = JSON.parse(messagesData);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (e) {
        console.error('Failed to parse localStorage messages:', e);
        return [];
    }
};
export const updateComponentOpenState = (isOpen) => {
    const aiLocalStorage = getLocalStorage();
    setLocalStorage(Object.assign(Object.assign({}, aiLocalStorage), { isComponentOpen: isOpen, componentOpenTimestamp: isOpen ? Date.now() : undefined }));
};
export const getComponentOpenState = () => {
    const aiLocalStorage = getLocalStorage();
    if (aiLocalStorage.isComponentOpen && aiLocalStorage.componentOpenTimestamp) {
        const now = Date.now();
        const timeDiff = now - aiLocalStorage.componentOpenTimestamp;
        if (timeDiff < COMPONENT_EXPIRY_TIME) {
            return aiLocalStorage.isComponentOpen;
        }
    }
    return false;
};
//# sourceMappingURL=localStorage.js.map